import React, { useEffect, useState } from 'react';
import classNames from 'classnames';

import { useIntl } from '../../util/reactIntl';
import { APP_STORE_URL, PLAY_STORE_URL, isInsideMedianApp } from '../../util/appStore';

// Official, unmodified badge artwork - Apple and Google both require this.
import appStoreBadge from '../../assets/store-badges/download-on-the-app-store.svg';
import googlePlayBadge from '../../assets/store-badges/get-it-on-google-play.png';

import css from './StoreBadges.module.css';

/**
 * The official App Store and Google Play badges as links to the store pages.
 * Renders nothing inside the Median app wrapper (the user already has the
 * app) and starts hidden until mounted so app users never see a flash.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className
 * @param {boolean?} props.alwaysShow render even inside the app (used by the
 *   card, which does its own check)
 * @returns {JSX.Element|null}
 */
const StoreBadges = props => {
  const { className, alwaysShow } = props;
  const intl = useIntl();
  const [show, setShow] = useState(!!alwaysShow);

  useEffect(() => {
    if (!alwaysShow) {
      setShow(!isInsideMedianApp());
    }
  }, [alwaysShow]);

  if (!show) {
    return null;
  }

  return (
    <div className={classNames(css.root, className)}>
      <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
        <img
          className={css.appStoreBadge}
          src={appStoreBadge}
          alt={intl.formatMessage({ id: 'AppDownloadCard.appStore' })}
        />
      </a>
      <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer">
        <img
          className={css.googlePlayBadge}
          src={googlePlayBadge}
          alt={intl.formatMessage({ id: 'AppDownloadCard.googlePlay' })}
        />
      </a>
    </div>
  );
};

export default StoreBadges;
